import { HttpClient } from '@angular/common/http';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { base64ToArrayBuffer, saveByteArray } from 'app/helpers/blobDownload';
import { DialogGeneral } from '../../DialogGeneral';

export interface DialogPdfViewPdfData {
    header: string;
    // Má vera src eða base64 src
    pdfSrc: string;
    fileName: string;
    isBase64: boolean;
}

@Component({
    selector: 'dialog-pdf-view',
    templateUrl: 'dialog-pdf-view.html',
    styleUrls: ['dialog-pdf-view.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogPdfViewPdf extends DialogGeneral {
    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<DialogPdfViewPdf>,
        private http: HttpClient,
        public dialogRef: MatDialogRef<DialogPdfViewPdf>,
        @Inject(MAT_DIALOG_DATA) public data: DialogPdfViewPdfData
    ) {
        super(matDialogRef);
    }

    downloadPdf(filename, file, isBase64 = false) {
        let _this;
        if (isBase64) {
            var sampleArr = base64ToArrayBuffer(file);
            saveByteArray(this.data.fileName, sampleArr);
        } else {
            this.http.get(file, { responseType: 'arraybuffer' }).subscribe(function (data) {
                saveByteArray(filename, data);
            });
        }
    }
}
